import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-informations-bien-read-mode',
  templateUrl: './informations-bien-read-mode.component.html',
  styleUrls: ['./informations-bien-read-mode.component.scss'],
})
export class InformationsBienReadModeComponent {
  @Input() informationsBien!: Report.Property;
}
